<template>
    <div class="row">
        <input-select class="col-10" label="Tipo" ref="tipo" required :options="options.tipo" v-model="form.tipo"/>
        <input-radio class="col-2" label="Publicada?" ref="publicada" required :options="options.simnao" v-model="form.concluida" />
       
        <input-date-time class="col-12 col-md-4" :label="`${form.concluida == 'S' ? 'Data da publicação' : 'Data de previsão'}`" ref="data" required v-model="form.dataConclusao"/>
        <input-select class="col-12 col-md-4" label="Membro capacitado" ref="membro" required :options="options.membros" v-model="form.membroCapacitadoId"/>
        <input-mask class="col-12 col-md-4" mask="##.###.###/####-##" label="CNPJ Capacitadora" ref="cnpj" v-model="form.cnpjCapacitadora" required/>
       
        <input-text class="col-12" label="Área de pesquisa" placeholder="Máximo 50 caracteres" :max-length="50" ref="nome" required v-model="form.areaPesquisa"/>
        <input-text class="col-12" label="Titulo do trabalho" placeholder="Máximo 200 caracteres" :max-length="200" ref="nome" required v-model="form.tituloTrabalho"/>

        <div class="col-12">
            <upload v-if="!form.nomeArquivoAWS"
                id="capacitacao_profissional" 
                tituloArquivo="Arrastar PDF" 
                selecioneArquivo="Selecionar o PDF"  
                type=".pdf" 

                :arquivo-download="form.arquivoBase64"
                :arquivo-download-nome="form.nomeArquivoAWSUP"
                
                @upload="(file, nomeArquivo)=> {                   
                    form.arquivoBase64 = file;
                    form.nomeArquivoAWSUP = nomeArquivo;
                    this.$forceUpdate();
                }" 
            />

            <template v-if="form.nomeArquivoAWS">
                <div>
                    Arquivo
                    <div class="lista-arquivos d-flex">
                        <b-button variant="danger" @click="() =>{this.form.nomeArquivoAWS = null;}" class="m-2" size="sm">
                            <b-icon icon="trash" class="mr-2" />
                            Remover arquivo
                        </b-button>
                        <b-button variant="info" @click="() => {this.$emit('downloadArquivo', this.form.id);}" class="m-2" size="sm">
                            <i class="fas fa-cloud-download"></i>
                        </b-button>
                        <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                            {{form.nomeArquivoAWS}}
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect.vue";
import InputRadio from "@/components/inputs/InputRadio.vue";
import InputText from "@/components/inputs/InputText.vue";
import InputMask from "@/components/inputs/InputMask.vue";
import InputDateTime from "@/components/inputs/InputDateTime.vue";
import Upload from "@/components/upload/Upload.vue";

import PessoaService from "@/common/services/pessoa/pessoa.service";

import helpers from "@/common/utils/helpers";

import {FormMixin} from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";

export default {
    name: "ModalCapacitacaoTecnologica",
    mixins: [FormMixin],
    props: {
        projetoId: {
            type: String,
            required: true
        },
    },
    components: {
        InputSelect,
        InputText,
        InputDateTime,
        Upload,
        InputRadio,
        InputMask,
    },    
    data : () => ({
        form : {
            tipo: null,
            concluida: 'N',
            dataConclusao: null,
            membroCapacitadoId: null,
            cnpjCapacitadora: null,
            areaPesquisa: null,
            tituloTrabalho: null,
            arquivoBase64: null,
            nomeArquivoAWS: null,
        },
        options : {
            tipo : helpers.getTiposCapacitacaoProfissional(),
            membros : [],
            simnao : [
                {value: 'S', text: "Sim"},
                {value: 'N', text: "Não"}
            ]
        }
    }),
    methods : {
        salvar : function(){
            let form = cloneDeep(this.form);

            this.$emit('salvar', form);
        },
        editar : function(e){
            let form = cloneDeep(e);
            form.dataConclusao = helpers.formatarDataBr(form.dataConclusao);
            form.membroCapacitadoId = form.membroCapacitado.id;

            this.form = form;
        },
        buscarMembrosCapacitados : function(){
            PessoaService.listar(this.empresaSelecionada.id).then(res => {
                this.options.membros = res.data.data.itens.map(el => {
                    return {
                        value: el.id,
                        text: el.nome
                    }
                });
            });
        },
    },
    mounted(){
        this.buscarMembrosCapacitados();
    }, 
    computed : {
        empresaSelecionada : function(){
            return this.$store.state.app.selectedCompanyObj;
        }
    }
}
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>